import request from './request';

export const authApi = {
    // 发送验证码
    sendCode(data) {
        return request.post('/auth/send-code', data);
    },

    // 登录
    login(data) {
        return request.post('/auth/login', data);
    },

    // 获取当前用户信息
    getCurrentUser() {
        return request.get('/users/me');
    },

    // 获取用户信息
    getUser(id) {
        return request.get(`/users/${id}`);
    },

    // 获取用户详细信息(管理员)
    getUserAdvanced(id) {
        return request.get(`/users/advanced/${id}`);
    }
}; 